module.exports = __webpack_public_path__ + "img/fas-volume-low.50fe80bf.svg";